import { CameraDocumentIcon } from './CameraDocumentIcon';

/**
 * author: snis
 * id 8A2FFEED-01B4-44C0-A82A-2E03D8C2A447
 * name camera-document
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-document.svg
 * tags
 * - Photography 
 */
export const OverheadProjectorIcon = CameraDocumentIcon;
export default OverheadProjectorIcon